export default __webpack_public_path__ + "img/0.6e9e612e.jpg";